import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import CustomCircualrProgress from './CustomCircualrProgress';
import {InsertDriveFile} from "@mui/icons-material";
import {Box, Typography} from "@mui/material";

interface IProps {
    type?: 'image' | 'video' | 'media' | 'file',
    file?: File,
    loaded?: number,
    url?: string,
}

export default function PreviewUpload({ type = "image", file, loaded, url }: IProps) {
    switch (type) {
        case "image":
            if (url) {
                return <div className="relative h-14 w-14">
                    <img className="h-14 w-14 rounded object-cover" src={url} />
                </div>
            } else {
                return <div className="relative h-14 w-14">
                    {loaded! < 100 && <CustomCircualrProgress value={loaded!} size={25} />}
                    <img className="h-14 w-14 rounded object-cover" src={URL.createObjectURL(file!)} />
                </div>
            }
        case "video":
            if (url) {
                return <div className="relative h-14 w-14">
                    <video className="h-14 w-14 rounded object-cover  " src={url} />
                </div>
            } else {
                return <div className="relative h-14 w-14">
                    {loaded! < 100 ? <CustomCircualrProgress value={loaded!} size={25} /> : <PlayCircleIcon className="center text-action-active" />}
                    <video className="h-14 w-14 rounded object-cover  " src={URL.createObjectURL(file!)} />
                </div>
            }
        case "media":
        case "file":
            if (url) {
                return <div className="relative h-14 w-14">
                    {url?.split('.').pop() === 'mp4' ?
                        <video className="h-14 w-14 rounded object-cover  " src={url}/> :
                        (type === 'media' || ["jpg", "png", "jpeg", "webp", "jfif"].indexOf(url?.split('.')?.pop() ?? '') > -1) ?
                            <img className="h-14 w-14 rounded object-cover  " src={url}/> :
                            <Box className={'relative'}>
                                <InsertDriveFile className="h-14 w-14 rounded object-cover text-gray-300 "/>
                                <Typography className={'absolute right-3 left-3 truncate bottom-1'}>{url?.split('.').pop()}</Typography>
                            </Box>

                    }
                </div>
            } else {
                return <div className="relative h-14 w-14">
                    {loaded! < 100 && <CustomCircualrProgress value={loaded!} size={25}/>}
                    {file?.type?.split('/')?.[0] === 'video' ?
                        <video className="h-14 w-14 rounded object-cover  " src={URL.createObjectURL(file!)}/> :
                        (type === 'media' || file?.type?.split('/')?.[0] === 'image') ?
                            <img className="h-14 w-14 rounded object-cover  " src={URL.createObjectURL(file!)}/> :
                            <Box className={'relative'}>
                                <InsertDriveFile className="h-14 w-14 rounded object-cover text-gray-300 "/>
                                <Typography className={'absolute right-3 left-3 truncate bottom-1'}>{file?.type?.split('/')?.[1]}</Typography>
                            </Box>
                    }
                </div>
            }
    }
}
